import styled from 'styled-components';

export const UpdateStyled = styled.div`
  /* 头部背景色 */
  th {
    font-size: 16px;
    /* color: ${(props) => props.theme[props.brand].table.thHeadColor}; */
    background: ${(props) => props.theme[props.brand].table.thHeadBckColor};
  }
  .update-box {
    width: 100%;
    display: block;

    .ant-upload {
      width: 100%;

      > span {
        display: block;
      }
    }
    .ant-upload-list {
      display: none;
    }
  }
`;
